<!--
 * @Description:单独添加预采购任务量
 * @Date: 2023/4/20 下午3:41:37
-->
<template>
  <BaseDialog
    width="450px"
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="单独添加预采购任务量"
  >
    <div style="padding: 20px">
      <BaseForm
        ref="formRef"
        :model="formData"
        label-width="auto"
        label-position="right"
      >
        <BaseFormItem
          label="姓名："
          prop="name"
          :rules="[{ required: true, message: '姓名必填' }]"
        >
          <BaseInput
            style="width: 100%"
            placeholder="请输入姓名"
            v-model="formData.name"
            maxlength="30"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem
          label="手机号："
          prop="phone"
          :rules="[{ required: true, message: '手机号必填' }]"
        >
          <BaseInput
            style="width: 100%"
            placeholder="请输入手机号"
            v-model="formData.phone"
            type="tel"
            maxlength="11"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem
          v-if="!isSceneType19"
          label="预采购任务量："
          prop="procurementTaskQuantity"
          :rules="[{ required: true, message: '预采购任务量必填' }]"
        >
          <BaseInput
            style="width: 100%"
            placeholder="请输入预采购任务量"
            v-model="formData.procurementTaskQuantity"
            :inputTextReplace="true"
            maxlength="6"
            :inputTexts="['数字']"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="人员标签：" prop="userTag">
          <BaseAutocomplete
            style="width: 100%"
            placeholder="请输入人员标签"
            v-model="formData.userTag"
            :fetch-suggestions="
              async (queryString, cb) => {
                const { data } = await userTags({
                  projectId: projectId
                });
                const list = data.map(item => {
                  return { value: item.label, label: item.label };
                });
                if (list.length === 1 && list[0].value === '未设置') {
                  return cb([]);
                }
                return cb(
                  list.filter(
                    i => !queryString || i.value?.indexOf(queryString) > -1
                  )
                );
              }
            "
          ></BaseAutocomplete>
        </BaseFormItem>
        <BaseFormItem
          :rules="[
            { required: true, message: '请选择日期', trigger: 'change' }
          ]"
          label="预采购时间："
          prop="prePurchaseAt"
        >
          <BaseDatePicker
            style="width: 100%"
            :disabledDate="disabledDate"
            v-model="formData.prePurchaseAt"
          ></BaseDatePicker>
        </BaseFormItem>
        <base-form-item
          :rules="[{ required: true, message: '请选择导入方式' }]"
          label="导入方式："
          prop="importMethod"
        >
          <div>
            <base-radio-group v-model="formData.importMethod">
              <base-radio :value="1">覆盖原数据</base-radio>
              <base-radio :value="2">累加原数据</base-radio>
            </base-radio-group>
          </div>
        </base-form-item>
      </BaseForm>
    </div>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onSave" type="primary">确定</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { defineProps, withDefaults, reactive, ref, defineEmits } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseInput,
  BaseButton,
  BaseRadio,
  BaseRadioGroup,
  BaseAutocomplete,
  BaseDatePicker
} from 'xrk-components';
import { preProcurementTaskQuantity } from '../data-source/apis';
import { userTags } from '@/views/project-task/src/data-source/apis';
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    projectId: number;
    isSceneType19: boolean;
  }>(),
  {
    remove() {
      return () => ({});
    },
    projectId: null
  }
);
const emits = defineEmits(['success']);
const formRef = ref<BaseFormRef>(null);
const formData = reactive<{
  name: string;
  phone: number;
  procurementTaskQuantity: number;
  userTag: string;
  prePurchaseAt: string;
  importMethod: number;
}>({
  name: '',
  phone: null,
  procurementTaskQuantity: null,
  userTag: '',
  prePurchaseAt: '',
  importMethod: null
});
const disabledDate = time => {
  const cur = new Date();
  const curDate = cur.getDate() - 1;
  cur.setDate(curDate);
  return time.getTime() < cur.getTime();
};
const onSave = async () => {
  await formRef.value.validate();
  await preProcurementTaskQuantity({
    projectId: props.projectId,
    name: formData.name,
    phone: formData.phone,
    procurementTaskQuantity: formData.procurementTaskQuantity,
    userTag: formData.userTag,
    prePurchaseAt: formData.prePurchaseAt,
    importMethod: formData.importMethod
  });
  emits('success');
  onCancel();
};
const onCancel = () => {
  props.remove();
};
</script>
